import Vue from "vue";

export async function analyseEtablishedFacts(productId, payload) {
  return Vue.prototype.$http.post(
    `/products/${productId}/LLM/established_facts`,
    payload
  );
}

export async function showEtablishedFacts(productId) {
  return Vue.prototype.$http.get(
    `/products/${productId}/LLM/established_facts`
  );
}

export async function approveEtablishedFacts(productId, payload) {
  return Vue.prototype.$http.post(
    `/products/${productId}/LLM/established_facts/approve`,
    payload
  );
}
